import { callApi } from "@/api/api-core";

export const fetchInfo = function(ownerHandlesFailure) {
    return callApi(
        "POST",
        "v3/products/timeticket/info",
        undefined,
        ownerHandlesFailure
    );
};

export const fetchProducts = function(page = 1, ownerHandlesFailure) {
    return callApi(
        "POST",
        "v2/products/timeticket/all",
        { page },
        ownerHandlesFailure
    );
};

export const calculatePrice = function(
    departureInstant,
    passengers,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v2/products/timeticket/price/calculate",
        {
            departureInstant,
            passengers
        },
        ownerHandlesFailure
    );
};

export const createOrder = function(
    departureInstant,
    passengers,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v3/products/timeticket/order",
        {
            departureInstant,
            passengers,
            salesChannelIdentifier: "Webshop"
        },
        ownerHandlesFailure
    );
};
